const BnbIcon = ({ className = "", size = 64 }: { className?: string; size?: number }) => (
  <svg
    viewBox="0 0 64 64"
    width={size}
    height={size}
    className={className}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="32" cy="32" r="30" fill="url(#bnbGrad)" stroke="url(#bnbStroke)" strokeWidth="2" />
    <path
      d="M32 16L24 24l-4-4 12-12 12 12-4 4-8-8zm0 32l8-8 4 4-12 12-12-12 4-4 8 8zm16-16l-4 4-12-12 12-12 4 4-8 8 8 8zm-32 0l4-4 12 12-12 12-4-4 8-8-8-8z"
      fill="#1a1a2e"
      transform="scale(0.55) translate(26, 26)"
    />
    <text
      x="32"
      y="40"
      textAnchor="middle"
      fontFamily="Orbitron, sans-serif"
      fontWeight="700"
      fontSize="20"
      fill="#1a1a2e"
    >
      BNB
    </text>
    <defs>
      <linearGradient id="bnbGrad" x1="0" y1="0" x2="64" y2="64">
        <stop offset="0%" stopColor="#F0B90B" />
        <stop offset="100%" stopColor="#FFD700" />
      </linearGradient>
      <linearGradient id="bnbStroke" x1="0" y1="0" x2="64" y2="64">
        <stop offset="0%" stopColor="#FFE44D" />
        <stop offset="100%" stopColor="#B8860B" />
      </linearGradient>
    </defs>
  </svg>
);

export default BnbIcon;
